import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-progress-bar.css';
var getClassNameList = classNames.bind(styles);
var UitkProgressBar = function (props) {
  var percent = props.percent,
    progressDescription = props.progressDescription,
    title = props.title,
    accessibilityLabel = props.accessibilityLabel,
    theme = props.theme;
  var barFillStyle = {
    // eslint-disable-next-line capitalized-comments
    width: "".concat(Math.max(0, percent), "%") // stylelint-disable
  };
  var baseClassName = 'uitk-progress-bar';
  var progressBarFillClassNames = getClassNameList("".concat(baseClassName, "-fill"), theme && "".concat(baseClassName, "-").concat(theme));
  return React.createElement("div", {
    className: getClassNameList(baseClassName)
  }, React.createElement(UitkLayoutFlex, {
    space: "three",
    justifyContent: "space-between"
  }, accessibilityLabel && React.createElement("span", {
    className: getClassNameList('is-visually-hidden', "".concat(baseClassName, "-a11y-label"))
  }, "".concat(accessibilityLabel, "\" \"")), React.createElement(UitkLayoutFlexItem, {
    className: getClassNameList("".concat(baseClassName, "-label")),
    grow: 1
  }, React.createElement("div", {
    "aria-hidden": Boolean(accessibilityLabel)
  }, title)), React.createElement(UitkLayoutFlexItem, {
    className: getClassNameList("".concat(baseClassName, "-value")),
    alignSelf: "end"
  }, React.createElement("div", {
    "aria-hidden": Boolean(accessibilityLabel)
  }, progressDescription))), React.createElement("div", {
    className: getClassNameList("".concat(baseClassName, "-track"))
  }, !accessibilityLabel && React.createElement("span", {
    className: getClassNameList('is-visually-hidden')
  }, "".concat("\" \"").concat(title, " ").concat(barFillStyle.width)), React.createElement("div", {
    className: progressBarFillClassNames,
    style: barFillStyle
  })));
};
UitkProgressBar.defaultProps = {
  theme: 'standard'
};
UitkProgressBar.displayName = 'UitkProgressBar';
export { UitkProgressBar };